import type {TvmList} from '../../types'

export const TESTING = {
  exp3: {host: 'exp3-matcher.taxi.tst.yandex.net', name: 'experiments3', id: 2013670},
  account: {name: 'delivery-frontend-account', id: 2049693},
  auth: {name: 'delivery-frontend-auth', id: 2049641},
  route: {name: 'delivery-frontend-route', id: 2049681},
  tariffs: {name: 'delivery-frontend-tariffs', id: 2046185},
} as const satisfies TvmList
